import { CentralizedLogin, Config } from '@foxcorp/foxkit-profile-js/centralized-login';
import { signOut } from 'State/User';
import { getXid } from 'Api/ProfileApi';
import { mapEnvironment } from './ProfileSDK';
import { cookieManager } from './CookieManager';
import { getCookieDomain, getCookieName } from './AuthStore';
import { getAppConfig, initUserState } from 'State/store';
import { HIDE_SECOND_SCREEN_QUERY_PARAM, SHOW_SECOND_SCREEN_OPTION_PARAM } from './Constants';
import { getHeapCDC } from './Analytics/Heap';

//Helpers related to CentralizedLoginSDK

let centralizedLogin = {};

export const centralizedLoginSDK = () => {
  if (!Object.keys(centralizedLogin).length) {
    createCentralizedLogin();
  }

  return centralizedLogin;
};

export const createCentralizedLogin = () => {
  const { authClientId, appVersion, appEnv, accountApiKey, authRedirectUri, authUrl, identityApiBaseUrl } =
    getAppConfig().defaultConfig;

  const config = {
    apiKey: accountApiKey,
    clientId: authClientId,
    redirectUri: authRedirectUri,
    environment: mapEnvironment(appEnv),
    appName: 'fox-nation-commerce',
    isSsr: typeof window === 'undefined',
    appVersion,
    authBaseUrl: authUrl,
    baseUrl: identityApiBaseUrl ? identityApiBaseUrl : undefined,
    useEksEndPoints: false,
    statefulRefreshToken: {
      useHydraForRefresh: true,
      cookieManager: cookieManager(),
      authCookieDomain: getCookieDomain(),
      authCookieName: getCookieName(),
      onRefreshSuccess: () => {
        initUserState();
      },
      onRefreshError: (error) => {
        console.error('[CentralizedLoginSDK][core] onRefreshError', error);

        if (typeof window !== 'undefined') {
          signOut(true);
        }
      },
      use: true,
    },
  };

  const centralizedLoginConfig = new Config(config);
  centralizedLogin = new CentralizedLogin(centralizedLoginConfig);
};

export const callCentralAuthLogin = async (params) => {
  const { xid } = getXid();

  if (!xid) {
    throw new Error('Could not get XID');
  }

  if (!centralizedLoginSDK || typeof window === 'undefined') {
    throw new Error('CentralizedLoginSDK not initialized');
  }

  const heapUrl = await getHeapCDC();

  const searchParams = new URLSearchParams(window.location ? window.location.search : '');

  const hideSecondScreenParam = searchParams.get(HIDE_SECOND_SCREEN_QUERY_PARAM) === 'true';

  await centralizedLoginSDK().login({
    deviceId: xid,
    heap5CdcUrl: heapUrl,
    ...params,
    optionalParams: {
      ...(params?.optionalParams ?? {}),
      ...(hideSecondScreenParam ? {} : { [SHOW_SECOND_SCREEN_OPTION_PARAM]: 'true' }),
    },
  });
};
